import ContentLoader from "react-content-loader"

const YoutubeNewsLoader = () => (
    <ContentLoader
        speed={2}
        width={'100%'}
        height={360}
        // viewBox="0 0 300 360"
        backgroundColor="#C2C2C2"
        foregroundColor="#ecebeb"
        className="horizontal-news-loader"
    >
        <rect x="1%" y="0" rx="0" ry="0" width="100%" height="145" />
        <rect x="1%" y="160" rx="0" ry="0" width="100%" height="20" />
        <rect x="1%" y="200" rx="0" ry="0" width="100%" height="20" />
        <rect x="1%" y="240" rx="0" ry="0" width="100%" height="20" />
    </ContentLoader>
)

export default YoutubeNewsLoader

